
<div
	class="news"
	[ngClass]="{ 'newsUnfolded': bUnfoldedNews }"
>

	<div
		class="newsFirstLine"
		[ngStyle]="{ opacity: news.bReleased ? '1' : '.6' }"
	>

		@if( news.url ) {

			<a
				href="{{news.url}}"
				target="blank"
				(click)="markNewsAsRead()"
			>
				<div class="newsTitleText">
					<span *ngIf="news.creationTms !== null">{{ news.creationTms | date: "dd.MM.YYYY" }}</span>
					<span *ngIf="news.creationTms === null">Unbekannte Erstellungszeit</span>
					<span class="newsName">{{ news.title }}</span>
				</div>
			</a>

		}
		@else {

			<div
				class="newsTitleText"
				(click)="toggleNewsContentDisplay()"
			>
				<span *ngIf="news.creationTms !== null">{{ news.creationTms | date: "dd.MM.YYYY" }}</span>
				<span *ngIf="news.creationTms === null">Unbekannte Erstellungszeit</span>
				<span class="newsName">{{ news.title }}</span>
			</div>

		}



		<div style="display: flex; flex-flow: row wrap; gap: 1em">

			<span
				*ngIf="bAdmin"
				(click)="clickEdit( news.id )"
				class="material-icons customBtn"
				title="Bearbeiten"
			>
				edit
			</span>

			<a
				*ngIf="!news.url"
				class="material-icons customBtn"
				title="Drucken"
				[routerLink]="['/News_drucken']"
				[queryParams]="{ id: news.id }"
				target="_blank"
			>
				print
			</a>

			<span
				*ngIf="news.url"
				class="material-icons"
				title="externe Webseite"
				style="cursor: default"
			>
				language
			</span>

			<span
				*ngIf="bAdmin && news.bReleased && bShowRelease"
				class="material-icons"
				title="Freigegeben"
				style="cursor: default;"
			>
				cell_tower
			</span>

		</div>


	</div>

	@if( bUnfoldedNews ) {
	
		<div
			*ngIf="news.content"
			class="infoBlock"
		>
			<div class="label">Beschreibung</div>

			<div
				class="htmlViewer"
				[innerHTML]="domSanitizer.bypassSecurityTrustHtml( news.content )"
			>
			</div>
		</div>
	
		<div *ngIf="contactPerson" class="infoBlock">
		  <div class="label">Ansprechpartner</div>
		  <div>{{contactPerson}}</div>
		  <div>{{contactPersonPhone}}</div>
		  <a href="mailto:{{contactPersonEmail}}">{{contactPersonEmail}}</a>
		</div>
	
	
		<div
			*ngIf="news.myFiles.length"
			class="infoBlock"
		>

			<div class="label">Angehängte Dateien</div>

			<div
				*ngFor="let attachedFile of news.myFiles"
				class="fileLine"
			>
				<div>
					<span
						class="fileName"
						(click)="downloadFile(attachedFile)"
					>
						{{attachedFile.file.name}}
					</span>
				</div>

			</div>

		</div>
	
	}

</div>
